import { Box, Button } from '@mui/material'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RightSlider } from '../../../../../../components/sliders'
import { MetricsSelector } from '../../../../../../store/TechnologyMetrics'
import { GrantsMetrics } from '../../sharedComponents/GrantsMetrics'
import { RejectedGrants } from '../RejectedGrants'
import { MatchedGrants } from './MatchedGrants'
import { MatchedPFs } from './MatchedPFs'

export const Matches: React.FC = () => {

  const [showRejected, setShowRejected] = useState(false)

  const metrics = useSelector(MetricsSelector.makeMatchedGrantsMetrics)

  const actionButtons = {
    Rejected: (
      <Button
        onClick={() => setShowRejected(true)}
        sx={{ fontSize: '0.875rem', textTransform: 'none' }}
      >
        View all
      </Button>
    ),
  }


  return (
    <Box>
      <RightSlider
        open={showRejected}
        setOpen={setShowRejected}
        closeButtonAction={() => setShowRejected(false)}
      >
        <RejectedGrants />
      </RightSlider>

      <GrantsMetrics metrics={metrics} actionButtons={actionButtons} />

      <MatchedPFs />

      <MatchedGrants />
    </Box>
  )
}
